module.exports = __webpack_public_path__ + "media/images/logos/logo-glin-og-28e1fc0dec14d166a74848a4cb02b54f.jpg";